import { DataAmigavel } from "@/shared/utils/datas";
import { GrupoPorLocal } from "../components/agruparPorDefensoriaNucleo";
import { Key } from "react";
import { Page, Text, View } from "@react-pdf/renderer";
import { PageFooter } from "./ReportPageFooter";
import { chunkArray, corrigeProcessos, formatDate, somarQuantidade, textoCivelCriminal } from "../movimentacao.service";
import { parametrosRelatorioMovimentacoes } from "../components/ModalFiltrosMovimentacoes";
import { stylesMovimentacaoReport } from "../components/movimentacao-report-style";

interface IMyProps {
  dados: GrupoPorLocal[];
  parametros: parametrosRelatorioMovimentacoes
}

export function ReportPageDefense({ dados }: IMyProps) {

  const totalGeral = dados.reduce(
    (acc, cur) => acc + cur.recebimentos.reduce((ac2, rec) => ac2 + somarQuantidade(rec.registros), 0),
    0
  );

  return (
    <Page size="A4" style={stylesMovimentacaoReport.page} orientation="portrait">
      <Text style={stylesMovimentacaoReport.title}>Relatório de Movimentações por Defensoria/Núcleo</Text>

      {dados.map((grupoLocal: any, idx: any) => (
        <View key={idx} style={stylesMovimentacaoReport.section}>

          <Text style={stylesMovimentacaoReport.header}>{grupoLocal.nome}</Text>

          {grupoLocal.recebimentos?.map((rec: any, ridx: any) => (
            <View key={ridx} style={{ marginBottom: 10 }}>
              <Text>
                Ref: {formatDate(rec.referencia)} - Recebido em: {DataAmigavel(rec.data_recebimento)} - {textoCivelCriminal(rec.civel, rec.criminal)}
              </Text>
              <Text>
                {rec.defensoria} {rec.distrito} {rec.nucleo}
              </Text>

              {chunkArray(rec.registros, 20).map((chunk: any, chunkIndex: Key) => (
                <View key={chunkIndex} style={stylesMovimentacaoReport.table} wrap={false}>
                  <View style={stylesMovimentacaoReport.tableRow}>
                    <Text style={stylesMovimentacaoReport.tableColCTipo}>Tipo</Text>
                    <Text style={stylesMovimentacaoReport.tableColCProcessos}>Processos</Text>
                    <Text style={stylesMovimentacaoReport.tableColCQuantidade}>Qtde.</Text>
                  </View>
                  {chunk.map((reg: any, i: any) => (
                    <View style={stylesMovimentacaoReport.tableRow} key={i}>
                      <Text style={stylesMovimentacaoReport.tableColRTipo}>
                        {reg.tipo}
                        {reg.inicial ? " (inicial)" : ""}
                      </Text>
                      <Text style={stylesMovimentacaoReport.tableColRProcessos} wrap>
                        {corrigeProcessos(reg.processos)}
                      </Text>
                      <Text style={stylesMovimentacaoReport.tableColRQuantidade}>
                        {reg.quantidade}
                      </Text>
                    </View>
                  ))}

                  <View style={stylesMovimentacaoReport.tableRow}>
                    <Text
                      style={[
                        stylesMovimentacaoReport.tableColRTipo,
                        { fontWeight: "bold", width: "90%" },
                      ]}
                    >
                      Total por Local
                    </Text>
                    <Text
                      style={[
                        stylesMovimentacaoReport.tableColRQuantidade,
                        { fontWeight: "bold" },
                      ]}
                    >
                      {somarQuantidade(rec.registros)}
                    </Text>
                  </View>
                </View>
              ))}

              {rec.observacao && <Text>Observação: {rec.observacao}</Text>}
            </View>
          ))}

          <Text style={{ fontWeight: "bold", marginTop: 5 }}>
            Total da Defensoria/Núcleo ({grupoLocal.nome}): {grupoLocal.recebimentos.reduce((acc: any, rec: any) => acc + somarQuantidade(rec.registros), 0)}
          </Text>

          <View style={{ height: 10 }}></View>
        </View>
      ))}

      <Text>
        Total Geral: {Intl.NumberFormat("pt-BR", { style: "decimal" }).format(totalGeral)}
      </Text>

      <PageFooter />
    </Page>
  )
}